import React, { useState, Suspense, useEffect, useRef } from "react";
import { Modal, Button } from "react-bootstrap";
import { Icon } from "semantic-ui-react";

import CommonModal from "../../../components/CommonModal";
import "../../../components/CommonModal/manage-roster-modal.css";

import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Dimmer, Loader, Message, Transition } from "semantic-ui-react";
import MicrosoftLogin from "react-microsoft-login";
import axios from "axios";

import { control } from 'react-validation';
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import CheckButton from "react-validation/build/button";

import { checkSsoStatus, login, ssoUserLoggedIn } from "../../../Redux/Actions/authAction";
import "../../../config";
import SSOLogin from "../SSOLogin";
import './Login.css';

const required = (value) => {
  if (!value) {
    return (
      <div className="alert alert-danger d-block" role="alert">
        This field is required!
      </div>
    );
  }
};

const HOCInput = ({ error, isChanged, isUsed, icon, ...props }) => (
  <div className="form-group">
    <div className="input-group-prepend">
      <span className="input-group-text prepend-icon">{icon}</span>
      <div className="text-input-container">
        <input {...props} />
      </div>
    </div>
    <div className="input-error">
      {isChanged && isUsed && error}
    </div>
  </div>

);

const MyValidationInput = control(HOCInput);

const Login = (props) => {
  const form = useRef();
  const checkBtn = useRef();
  const testClientId = "e284194e-3218-4557-be77-6643231d35b1";
  const defaultType = "Microsoft";
  const [ssoClientId, setSsoClientId] = useState(testClientId);
  const [ssoTenantUrl, setSsoTenantUrl] = useState("");
  const [ssoType, setSsoType] = useState(defaultType);
  const [msalInstance, onMsalInstanceChange] = useState();
  const [showDefaultLogin, setShowDefaultLogin] = useState(false);
  const [showMicrosoftLogin, setShowMicrosoftLogin] = useState(false);
  const [showSsoLogin, setShowSsoLogin] = useState(false);

  // TODO: get this from the db
  const [companyId, setCompanyId] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [showForgotPasswordModal, setShowForgotPasswordModal] = useState(false);
  const [showSsoHelpModal, setShowSsoHelpModal] = useState(false);

  const { isLoggedIn, user: currentUser } = useSelector((state) => state.auth);
  const { message } = useSelector((state) => state.msg);
  const baseApiUrl = global.config.baseApiUrl;

  const dispatch = useDispatch();
  const navigate = useNavigate();

  //get the config companyId to retrieve companyInfo from DB
  useEffect(() => {
    setCompanyId(global.config.companyId);

    // TODO get companyInfo from DB
    dispatch(checkSsoStatus(global.config.companyId)).then((ssoInfo) => {
      //console.log("ssoInfo : " + JSON.stringify(ssoInfo));

      if (!ssoInfo) {
        //ssoInfo is not present; use default login
        setSsoClientId(null);
        setSsoTenantUrl("");
        setSsoType("default");
        setShowDefaultLogin(true);
      } else {
        //if defaultLoginEnabled, show regular login form in addition to sso
        if (ssoInfo.defaultLoginEnabled === "Y") {
          setShowDefaultLogin(true);
        } else {
          setShowDefaultLogin(false);
        }
        //check through available configurations
        //for now we only support ONE entry
        if (ssoInfo.ssoConfig && ssoInfo.ssoConfig[0]) {
          //console.log("ssoConfig result ONE: " + JSON.stringify(ssoInfo.ssoConfig[0]));
          let ssoConfig = {};
          ssoConfig = Object.assign(ssoConfig, ssoInfo.ssoConfig[0]);
          //allow for multiple types
          switch (ssoConfig.ssoType) {
            case "Microsoft":
              setShowMicrosoftLogin(true);
              break;
            case "SAML":
              setShowSsoLogin(true);
              break;
            default:
              break;
          }
          setSsoClientId(ssoConfig.tenantId);
          setSsoTenantUrl(ssoConfig.tenantUrl);
          setSsoType(ssoConfig.ssoType);
        }
        //TODO: Add support for displaying multiple sso options if configured
      }
    });
    // TODO Set SSO info
  }, [global.config.companyId]);

  const toInputUppercase = (e) => {
    e.target.value = ("" + e.target.value).toUpperCase();
  };

  const toInputLowercase = (e) => {
    e.target.value = ("" + e.target.value).toLowerCase();
  };

  const onChangeUsername = (e) => {
    const username = e.target.value;
    setUsername(username);
    setIsVisible(false);
  };

  const onChangePassword = (e) => {
    const password = e.target.value;
    setPassword(password);
    setIsVisible(false);
  };

  const handleDefaultLogin = (e) => {
    e.preventDefault();

    setLoading(true);

    setCompanyId(global.config.companyId);

    form.current.validateAll();

    if (checkBtn.current.context._errors.length === 0) {
      dispatch(login(companyId, username, password, null)).then(
        (signingIn) => {
          console.log("signingIn: " + JSON.stringify(signingIn));
          console.log("username: " + JSON.stringify(username));
          console.log("AUTH isLoggedIn: " + JSON.stringify(isLoggedIn));
          console.log("AUTH currentUser: " + JSON.stringify(currentUser));

          if (
            signingIn != null &&
            Object.keys(signingIn).length != 0 &&
            JSON.stringify(signingIn).length > 0 &&
            (signingIn.username.toLowerCase() === username.toLowerCase() ||
              String(signingIn.id).toLowerCase() === username.toLowerCase() || signingIn.email.toLowerCase() === username.toLowerCase())
          ) {
            //props.history.push("/profile");
            //window.location.reload();
            navigate("/profile");
          } else {
            console.log("INVALID LOGIN!!!!");
            setIsVisible(true);
            setLoading(false);
          }
        },
        (error) => {
          setIsVisible(true);
          setLoading(false);
        }
      );
    } else {
      setLoading(false);
    }
  };

  /*
  SINGLE-SIGN-ON HANDLER(S)
  */
  const handleSsoLogin = (err, authData) =>{
    console.log("Auth data is ", authData);
    console.log("err data is: ", err);
    dispatch(ssoUserLoggedIn(authData))
    .then(signingIn=>{
      console.log("signingIn: " + JSON.stringify(signingIn));
      //console.log("useremail: " + JSON.stringify(useremail));
      console.log("AUTH isLoggedIn: " + JSON.stringify(isLoggedIn));
      console.log("AUTH currentUser: " + JSON.stringify(currentUser));
      navigate("/profile");
    })
    .catch(err=>{
      setIsVisible(true);
      setLoading(false);
    })
  }
  //Microsoft SSO
  const handleMicrosoftLogin = (err, authData, msal) => {
    console.log(err, authData, msal);
    //check for valid username
    if (authData && authData.account.username) {
      
      if (!err && authData) {
        //onMsalInstanceChange(msal);
      }

      // call api to find that user in RR
      let useremail = authData.account.username;
      console.log("find useremail:authData.account.username: " + JSON.stringify(authData.account.username));

      let url = baseApiUrl + "/login";
      console.log("find user: url: " + url);
      //let testUserId = 1747053227;
      let reqBody = {
        userid: useremail,
        companyId: "",
        username: "",
        password: "",
      };
      console.log("The userid is: " + JSON.stringify(useremail));
      dispatch(login("", useremail, "", msal)).then(
        (signingIn) => {
          console.log("signingIn: " + JSON.stringify(signingIn));
          console.log("useremail: " + JSON.stringify(useremail));
          console.log("AUTH isLoggedIn: " + JSON.stringify(isLoggedIn));
          console.log("AUTH currentUser: " + JSON.stringify(currentUser));
          //NOTE: we can't validate returned user by email because email is not
          //part of the userInfo returned from login.
          navigate("/profile");
        },
        (error) => {
          setIsVisible(true);
          setLoading(false);
        }
      );
    } else {
      console.log("Not finding authData and authData.account.username");
    }
  };

  return (
    <Suspense
      fallback={
        <Dimmer active inverted>
          <Loader size="large">{"Loading..."}</Loader>
        </Dimmer>
      }
    >
      <div className="login-page">
        <div className="card py-3 px-4">
          <Form onSubmit={handleDefaultLogin} ref={form}>
            <div className="form-group">
              <label htmlFor="instructorsignin">
                <h3 className="card-title font-weight-bolder">Instructor Sign In</h3>
              </label>
              <hr className="hr w-100 m-0" />
            </div>

            <Transition visible={isVisible} animation="scale" duration={500}>
              <Message negative>
                <Message.Header>Invalid Username/Userid</Message.Header>
                <p>Please enter valid credentials.</p>
              </Message>
            </Transition>

            {showDefaultLogin && (
              <div>
                <div className="form-group">
                  <label className="label-head" htmlFor="username">Username</label>
                  <MyValidationInput
                    type="text"
                    className="form-control text-input"
                    name="username"
                    value={username}
                    onChange={onChangeUsername}
                    onInput={toInputLowercase}
                    validations={[required]}
                    icon={<Icon name="user" size="small" className="align-items-center m-auto" />}
                  />
                </div>

                <div className="form-group">
                  <label className="label-head" htmlFor="password">Password</label>
                  <MyValidationInput
                    type="password"
                    className="form-control text-input"
                    name="password"
                    value={password}
                    onChange={onChangePassword}
                    icon={<Icon name="lock" size="small" className="align-items-center m-auto" />}
                  />
                </div>

                <div className="form-group d-flex justify-content-between mb-4">
                  <div >
                    <button
                      className="btn btn-block standard-btn px-4 py-2"
                      disabled={loading}
                    >
                      {loading && (
                        <span className="spinner-border spinner-border-sm"></span>
                      )}
                      <span>Submit</span>
                    </button>
                  </div>
                  <div className="align-self-center">
                    <button
                      type="button"
                      className="link btn-block login-forgot-link"
                      onClick={() => setShowForgotPasswordModal(true)}
                    >
                      Forgot Password?
                    </button>
                  </div>
                </div>
                <hr className="hr w-100 mt-0 mb-3 term-divider" />
                <div className="form-group text-center login-alternatives">
                  <button
                    type="button"
                    className="link login-forgot-link"
                    onClick={() => setShowSsoHelpModal(true)}
                  >
                    My organization uses Single Sign-On
                  </button>
                </div>

              </div>
            )}

            {showSsoLogin && (
              <div style={{ textAlign: "center"}}>
                <SSOLogin authCallback={handleSsoLogin}/>
              </div>
            )}

            {showMicrosoftLogin && (
              <div style={{ textAlign: "center" }}>
                <MicrosoftLogin
                  clientId={ssoClientId}
                  tenantUrl={ssoTenantUrl}
                  authCallback={handleMicrosoftLogin}
                />
              </div>
            )}

            {message && (
              <div className="form-group">
                <div className="alert alert-danger" role="alert">
                  {message}
                </div>
              </div>
            )}
            <CheckButton style={{ display: "none" }} ref={checkBtn} />
          </Form>
        </div>
      </div>

      <CommonModal
        show={showForgotPasswordModal}
        onHide={() => setShowForgotPasswordModal(false)}
        title={<Modal.Title>Forgot your password?</Modal.Title>}
        footer={
          <Button type="button" variant="success" onClick={() => setShowForgotPasswordModal(false)}>
            Ok
          </Button>
        }
        modalProps={{
          centered: true,
          className: "manage-roster-modal",
        }}
      >
        <p className="mb-0">
          Please sign in using the username and password associated with your LMS. If you do not
          remember your credentials, please contact your LMS administrator for assistance.
        </p>
      </CommonModal>

      <CommonModal
        show={showSsoHelpModal}
        onHide={() => setShowSsoHelpModal(false)}
        title={<Modal.Title>Single Sign On Help</Modal.Title>}
        footer={
          <Button type="button" variant="success" onClick={() => setShowSsoHelpModal(false)}>
            Ok
          </Button>
        }
        modalProps={{
          centered: true,
          className: "manage-roster-modal",
        }}
      >
        <p className="mb-0">
          If your organization mandates the use of Single Sign On, contact your administrator to
          request your company&apos;s <strong>rapidRoster Single Sign On link</strong>
        </p>
      </CommonModal>
    </Suspense>
  );
};

export default Login;
